export const useElfsight = () => {
	useHead({
		script: [
			{
				src: 'https://static.elfsight.com/platform/platform.js',
				async: true,
			},
		],
	})
}
